import { makeStyles } from 'tss-react/mui';
import { Fab } from '@mui/material';

import { APPBAR_MAX_HEIGHT } from 'config/constants';
import spacing from 'lib/spacing';
import { Email } from '@mui/icons-material';

type Props = {
	onClick: () => any;
	disabled?: boolean;
};

function SendEmailIcon({ onClick, disabled }: Props) {
	const { classes } = useStyles();

	return (
		<Fab
			className={classes.fab}
			size="medium"
			variant="extended"
			color="primary"
			aria-label="add"
			onClick={() => !disabled && onClick()}
			disabled={disabled}
		>
			<Email className={classes.extendedIcon} />
			Enviar email
		</Fab>
	);
}

export default SendEmailIcon;

const useStyles = makeStyles()((theme) => ({
	fab: {
		position: 'fixed',
		[theme.breakpoints.up('sm')]: {
			top: `${APPBAR_MAX_HEIGHT - spacing(theme, 2)}px`,
			marginLeft: theme.spacing(43),
		},
		[theme.breakpoints.down('sm')]: {
			bottom: theme.spacing(2),
			right: theme.spacing(40),
		},
		transition: theme.transitions.create(['left'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		zIndex: theme.zIndex.drawer + 2,
	},
	extendedIcon: {
		marginRight: theme.spacing(1),
	},
}));
